import { render, staticRenderFns } from "./UserLocalAudiance.vue?vue&type=template&id=5c8dee16&"
import script from "./UserLocalAudiance.vue?vue&type=script&lang=js&"
export * from "./UserLocalAudiance.vue?vue&type=script&lang=js&"
import style0 from "./UserLocalAudiance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports